module.exports = __webpack_public_path__ + "1730912a8e1c1c1d57c1c554c9b49173.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/wechatpay.png
// module id = 449
// module chunks = 0